var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { File } from 'packages/core/File';
var TalentFileRepository = /** @class */ (function (_super) {
    __extends(TalentFileRepository, _super);
    function TalentFileRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = 'api/v2/talents/:talentId/files';
        _this.entity = File;
        return _this;
    }
    TalentFileRepository.prototype.allFilesForTalent = function (talentId, jobId) {
        return this.getAll(this.url, { talentId: talentId }, jobId ? { job_id: jobId } : null)
            .then(function (r) { return r.items; });
    };
    TalentFileRepository.prototype.uploadFileResponse = function (file) {
        var payload = new FormData();
        payload.append('file', file);
        payload.append('origin_name', file.name);
        return this.post('uploads', payload);
    };
    return TalentFileRepository;
}(AbstractRepository));
export { TalentFileRepository };
